module.exports = __webpack_public_path__ + "img/seguro.493cb5f4.svg";